import axios from 'axios';
import Cookies from 'js-cookie';

const getApiUrl = () => {
    const configUrl = window.__CONFIG__?.REACT_APP_API_URL;
    // If properly substituted, use it; otherwise fall back
    if (configUrl && !configUrl.startsWith('__')) {
        return configUrl;
    }
    return process.env.REACT_APP_API_URL || 'http://localhost:8000';
};

// Main axios instance for regular requests
const axiosInstance = axios.create({
    baseURL: getApiUrl(),
});

let handleLogoutCallback = () => {
    if (!['/login', '/registration'].includes(window.location.pathname)) {
        window.location.href = "/login";
    }
};

export const setLogoutHandler = (callback) => {
    handleLogoutCallback = callback;
};

axiosInstance.interceptors.request.use(config => {
    const accessToken = Cookies.get('token');
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    } else {
        console.warn('[DEBUG] No token cookie found - Authorization header NOT set');
    }

    const agreementDeclined = Cookies.get('agreement_declined');
    if (agreementDeclined) {
        config.headers['Agreement-Declined'] = String(agreementDeclined);
    }

    return config;
});

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = Cookies.get('refresh');
            if (!refreshToken) {
                handleLogoutCallback();
                return Promise.reject(error);
            }

            try {
                const { data } = await axios.post(
                    `${getApiUrl()}/api/v1/token/refresh/`,
                    { refresh: refreshToken }
                );

                // Set refreshed token with same cookie options for persistence
                Cookies.set('token', data.access, { path: '/', sameSite: 'Lax' });
                originalRequest.headers['Authorization'] = 'Bearer ' + data.access;

                return axiosInstance(originalRequest);
            } catch (refreshError) {
                handleLogoutCallback();
                return Promise.reject(refreshError);
            }
        }

        // Handle agreement prompt
        if (error.response?.data?.prompt_agreement) {
            window.location.href = "/user-agreement";
            return Promise.reject(error);
        }

        // Handle 403 forbidden
        if (error.response?.status === 403 && !originalRequest.url.includes('/api/v1/token/refresh/')) {
            handleLogoutCallback();
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
